// extracted by mini-css-extract-plugin
module.exports = {"Section10":"Section10_Section10__uZl2V","Layout1":"Section10_Layout1__aom01","introLink":"Section10_introLink__9YmUo"};